import { j as e } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import f from "react";
import { FormattedMessage as s, injectIntl as x } from "react-intl";
import { B as g } from "../../chunks/Button.Ccj-dDdM.js";
import { C as m } from "../../chunks/Checkbox.PFuVDlpI.js";
import { T as p } from "../../chunks/Text.BGhoO_e3.js";
import { c as h } from "../../chunks/index.CxSWpsOB.js";
import { c as C } from "../../chunks/index.C4-GUKyp.js";
import { B as l } from "../../chunks/Badge.DBCiAXBB.js";
import { getZendeskLocale as M } from "../../lib/utils/support-utils/index.js";
import { D as B, d as N, g as H, j as S, b as T, f as E } from "../../chunks/Dialog.CH2ZNDp8.js";
var t = /* @__PURE__ */ ((a) => (a[a.None = 0] = "None", a[a.Educate = 1] = "Educate", a[a.SoftWarn = 2] = "SoftWarn", a[a.HardWarn = 3] = "HardWarn", a[a.Discipline = 4] = "Discipline", a))(t || {});
const _ = (a) => {
  const r = Object.values(t).filter((n) => typeof n == "number");
  return typeof a == "number" && r.includes(a);
}, j = (a) => a === t.HardWarn || a === t.Discipline, y = C("", {
  variants: {
    level: {
      [t.None]: "tw-border-purple-800 tw-bg-purple-200",
      [t.Educate]: "tw-border-purple-800 tw-bg-purple-200",
      [t.SoftWarn]: "tw-border-yellow-900 tw-bg-yellow-200",
      [t.HardWarn]: "tw-border-red-800 tw-bg-red-100",
      [t.Discipline]: "tw-border-red-800 tw-bg-red-100"
    }
  }
}), w = ({
  level: a
}) => {
  switch (a) {
    case t.SoftWarn:
      return /* @__PURE__ */ e.jsx(l, { appearance: "yellow", children: /* @__PURE__ */ e.jsx(s, { id: "3SVI5p", defaultMessage: [{
        type: 0,
        value: "Warning"
      }] }) });
    case t.HardWarn:
      return /* @__PURE__ */ e.jsx(l, { appearance: "red", children: /* @__PURE__ */ e.jsx(s, { id: "3SVI5p", defaultMessage: [{
        type: 0,
        value: "Warning"
      }] }) });
    case t.Discipline:
      return /* @__PURE__ */ e.jsx(l, { appearance: "red", children: /* @__PURE__ */ e.jsx(s, { id: "YGKIVg", defaultMessage: [{
        type: 0,
        value: "Policy violation"
      }] }) });
    case t.Educate:
    default:
      return /* @__PURE__ */ e.jsx(l, { appearance: "dark-purple", children: /* @__PURE__ */ e.jsx(s, { id: "QOAy/W", defaultMessage: [{
        type: 0,
        value: "Reminder"
      }] }) });
  }
}, b = ({
  level: a,
  intl: r
}) => {
  const n = `https://support.peerspace.com/${M(r.locale)}/articles/10119319-why-keeping-your-bookings-on-peerspace-pays-off`;
  switch (a) {
    case t.SoftWarn:
      return /* @__PURE__ */ e.jsx(s, { id: "aO1cBi", defaultMessage: [{
        type: 0,
        value: "Several recent chats showed signs of off-platform booking. Booking off Peerspace violates our booking policy and can lead to removal from the platform. "
      }, {
        type: 1,
        value: "link"
      }], values: {
        link: /* @__PURE__ */ e.jsx("a", { href: n, className: "tw-underline", children: /* @__PURE__ */ e.jsx(s, { id: "TdTXXf", defaultMessage: [{
          type: 0,
          value: "Learn more"
        }] }) })
      } });
    case t.HardWarn:
      return /* @__PURE__ */ e.jsx(s, { id: "BBIH42", defaultMessage: [{
        type: 0,
        value: "Booking off Peerspace violates our booking policy and can lead to reduced search visibility, withheld payouts, or removal from the platform."
      }] });
    case t.Discipline:
      return /* @__PURE__ */ e.jsx(s, { id: "k3p65O", defaultMessage: [{
        type: 0,
        value: "We’ve identified repeated activity on your account that indicates bookings are being taken off Peerspace, in violation of our booking policy. Our team will be in touch with next steps."
      }] });
    case t.Educate:
    default:
      return /* @__PURE__ */ e.jsx(s, { id: "1tlSAc", defaultMessage: [{
        type: 0,
        value: "On-platform bookings come with guaranteed payouts, $1M liability insurance for your space, damage protection, and support if a guest dispute comes up. Booking off Peerspace means you lose those protections and can lead to removal from the platform. "
      }, {
        type: 1,
        value: "link"
      }], values: {
        link: /* @__PURE__ */ e.jsx("a", { href: n, className: "tw-underline", children: /* @__PURE__ */ e.jsx(s, { id: "TdTXXf", defaultMessage: [{
          type: 0,
          value: "Learn more"
        }] }) })
      } });
  }
}, v = ({
  level: a
}) => {
  switch (a) {
    case t.HardWarn:
    case t.Discipline:
      return /* @__PURE__ */ e.jsx(s, { id: "5h3TFE", defaultMessage: [{
        type: 0,
        value: "I agree"
      }] });
    case t.Educate:
    case t.SoftWarn:
    default:
      return /* @__PURE__ */ e.jsx(s, { id: "NYTGIb", defaultMessage: [{
        type: 0,
        value: "Got it"
      }] });
  }
}, k = ({
  level: a
}) => {
  switch (a) {
    case t.HardWarn:
    case t.Discipline:
      return /* @__PURE__ */ e.jsx(s, { id: "bnZ2cf", defaultMessage: [{
        type: 0,
        value: "I have read and understand the "
      }, {
        type: 1,
        value: "link"
      }], values: {
        link: /* @__PURE__ */ e.jsx("a", { href: "/legal/terms", className: "tw-underline", children: /* @__PURE__ */ e.jsx(s, { id: "frVy9H", defaultMessage: [{
          type: 0,
          value: "Peerspace booking policy"
        }] }) })
      } });
    default:
      return null;
  }
}, D = ({
  level: a
}) => {
  switch (a) {
    case t.SoftWarn:
      return /* @__PURE__ */ e.jsx(s, { id: "4Ij0i/", defaultMessage: [{
        type: 0,
        value: "Some of your conversations are moving off-platform"
      }] });
    case t.HardWarn:
      return /* @__PURE__ */ e.jsx(s, { id: "rD3Y0Y", defaultMessage: [{
        type: 0,
        value: "Your booking activity is being reviewed"
      }] });
    case t.Discipline:
      return /* @__PURE__ */ e.jsx(s, { id: "OOCfjj", defaultMessage: [{
        type: 0,
        value: "Your account is under review"
      }] });
    case t.Educate:
    default:
      return /* @__PURE__ */ e.jsx(s, { id: "kPNj6Q", defaultMessage: [{
        type: 0,
        value: "Keep bookings on Peerspace"
      }] });
  }
}, I = ({
  level: a,
  intl: r,
  className: n,
  onConsent: u
}) => {
  const [d, c] = f.useState(!1), o = j(a), i = () => {
    u?.({
      consented: o ? !!d : !0,
      level: a
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: h("tw-p-20 tw-rounded-8 tw-border-2 tw-flex tw-flex-col tw-gap-16", y({
    level: a
  }), n), children: [
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(w, { level: a }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-4", children: [
      /* @__PURE__ */ e.jsx(p, { typeface: "headline-3-m", className: "tw-text-gray-900", children: /* @__PURE__ */ e.jsx(D, { level: a }) }),
      /* @__PURE__ */ e.jsx(p, { typeface: "body-2", className: "tw-text-gray-900", children: /* @__PURE__ */ e.jsx(b, { level: a, intl: r }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-16", children: [
      o && /* @__PURE__ */ e.jsx(m, { id: "host-disintermediation-banner-consent", description: /* @__PURE__ */ e.jsx(k, { level: a }), variant: "box", onCheckedChange: c }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(g, { onClick: i, disabled: o && !d, children: /* @__PURE__ */ e.jsx(v, { level: a }) }) })
    ] })
  ] });
}, $ = x(I), O = ({
  level: a,
  intl: r,
  open: n,
  onOpenChange: u,
  onConsent: d
}) => {
  const [c, o] = f.useState(!1), i = j(a), W = () => {
    d?.({
      consented: i ? !!c : !0,
      level: a
    });
  };
  return /* @__PURE__ */ e.jsx(B, { open: n, onOpenChange: u, children: /* @__PURE__ */ e.jsxs(N, { className: h(y({
    level: a
  })), size: "lg", children: [
    /* @__PURE__ */ e.jsx(H, { showCloseButton: !1, children: /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-16", children: [
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(w, { level: a }) }),
      /* @__PURE__ */ e.jsx(S, { className: "tw-m-0", children: /* @__PURE__ */ e.jsx(D, { level: a }) })
    ] }) }),
    /* @__PURE__ */ e.jsx(T, { children: /* @__PURE__ */ e.jsx(p, { typeface: "body-2", className: "tw-text-gray-900", children: /* @__PURE__ */ e.jsx(b, { level: a, intl: r }) }) }),
    /* @__PURE__ */ e.jsx(E, { children: /* @__PURE__ */ e.jsxs("div", { className: "tw-w-full tw-flex tw-flex-col tw-gap-24", children: [
      i && /* @__PURE__ */ e.jsx(m, { id: "host-disintermediation-dialog-consent", description: /* @__PURE__ */ e.jsx(k, { level: a }), variant: "box", onCheckedChange: o }),
      /* @__PURE__ */ e.jsx("div", { className: "tw-flex tw-justify-center", children: /* @__PURE__ */ e.jsx(g, { onClick: W, disabled: i && !c, children: /* @__PURE__ */ e.jsx(v, { level: a }) }) })
    ] }) })
  ] }) });
}, z = x(O);
export {
  $ as HostDisintermediationBanner,
  z as HostDisintermediationDialog,
  t as HostDisintermediationRiskLevel,
  _ as isHostDisintermediationRiskLevel
};
//# sourceMappingURL=index.js.map
